// @ts-expect-error — importing js
import Faye, { type FayeClient } from 'faye'
import { DeferredSystem } from '../global/utils/DeferredSystem'
import { getRealtimeInfo } from './realtimeInfo'

const initRealtimeConnection = async () => {
  const { realtimeDomain } = await getRealtimeInfo()

  const fayeClient = new Faye.Client(realtimeDomain) as FayeClient
  fayeClient.disable('websocket')

  // needs a wrapper because the Faye Client is thenable
  return { client: fayeClient }
}

const realtimeConnection = new DeferredSystem(initRealtimeConnection)

const subscribe = async (
  privacy: 'public' | 'private',
  channel: `/${string}`,
  callback: (message: string) => unknown
) => {
  const { client } = await realtimeConnection.get()
  const { publicChannelId, privateChannelId } = await getRealtimeInfo()

  switch (privacy) {
    case 'public':
      return client.subscribe(publicChannelId + channel, callback)

    case 'private':
      return client.subscribe(privateChannelId + channel, callback)

    default:
      return undefined
  }
}

export { subscribe }
